module.exports = __webpack_public_path__ + "img/jz.21f78384.png";